import React from 'react';
import TextWinds from '../../../components/common/TextWinds';
import { Link } from 'react-router-dom';
import { orderDetailType } from '../../../constants/types/mypage-type';
import { TransactionBase } from '../../../constants/types';
import { numberWithCommas } from '../../../api/utils/format/numbers';
import { OrderStatusLabelEnum } from '../../../enum';
import { getLatestTransaction } from '../../../api/utils/order-item-transaction';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import OrderItemList from '../../../components/purchase/OrderItemList';

interface purchaseItemProps {
  props: orderDetailType;
  lastItemRef?: (node: HTMLDivElement) => void;
}
const PurchaseItem = ({ props, lastItemRef }: purchaseItemProps) => {
  const transactions: TransactionBase[] = props.transactions;
  const latestTransaction = getLatestTransaction(transactions);

  return (
    <div
      className="flex flex-col items-start justify-between gap-y-3 rounded-lg border border-gray2 p-3"
      ref={lastItemRef}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-col gap-2 lg:flex-row">
          <TextWinds type="caption1" color="gray9">
            {new Date(props.created_at).toLocaleString()}
          </TextWinds>
          <TextWinds type="caption1" color="gray9">
            {`주문번호 : ${props.id}`}
          </TextWinds>
        </div>
        <Link
          to={`/mypage/purchase/detail/${props.id}`}
          state={props}
          className="flex w-fit items-center justify-between text-right text-sm font-medium text-purple5"
        >
          주문 상세보기
          <ChevronRightIcon className="h-4 w-4" />
        </Link>
      </div>
      {/* 주문 상품 목록 */}
      <OrderItemList orderItems={props.template.order_items} />
      {/* 배송비가 있을 경우 */}
      {props.template.shipping_fee > 0 && (
        <div className="items-left flex w-full flex-col gap-x-1 p-2 text-left">
          <TextWinds type="content_body1">배송비</TextWinds>
          <div className="flex items-center gap-x-1">
            <TextWinds type="content_body1">
              {numberWithCommas(props.template.shipping_fee)} 원
            </TextWinds>
          </div>
        </div>
      )}

      <div className="flex flex-col items-start justify-start gap-y-2">
        <div>
          <span className="font-medium text-[#FF4F00]">
            {OrderStatusLabelEnum[props.status]}
            {/* {latestTransaction.method === 'DEPOSIT' ? '입금 ' : '승인 '}
            {TransactionStatusLabelEnum[latestTransaction.status]} */}
          </span>
        </div>
        {latestTransaction.status === 'DEPOSIT_REQUESTED' && (
          <div className="grid grid-cols-[auto,1fr] gap-x-5">
            <div>예금주</div>
            <div>{latestTransaction.depositName}</div>
            <div>입금계좌</div>
            <div>
              {latestTransaction.bankName} {latestTransaction.accountNo}
            </div>
            <div>입금기한</div>
            <div>{latestTransaction.expiryDate}</div>
          </div>
        )}
      </div>

      {/* {props.status} */}
      {/*     
                "PENDING",
                "PAY_RECIEVED",
                "REFUND_COMPLETE",
                "COMPLETE"
            */}
      <div className="w-full border-t border-gray2 pt-3 text-center font-bold">
        {' '}
        총 합계 : {numberWithCommas(props.template.total_price)} 원
      </div>
      {/* <PurchaseShippingStatus status={props.status} /> */}
      {/* <div className="flex flex-col gap-y-1 w-full">
            <TextWinds type="sub_title01" color="orange">
                입금 대기중
            </TextWinds>
            <TextWinds type="content_body2">받을분 {props.deposit}</TextWinds>
            <TextWinds type="content_body2">입금계좌 {props.account}</TextWinds>
            <TextWinds type="content_body2">입금기한 {props.deadline}까지</TextWinds>
        </div> */}
    </div>
  );
};

export default PurchaseItem;
